import React, { useState, useEffect } from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { ThemeContext } from './ThemeContext';
import { AuthProvider } from './context/AuthContext';

import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './styles/origenes.css';

import Sidebar from './components/Sidebar';
import Topbar from './components/Topbar';
import PrivateRoute from './components/PrivateRoute';

import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Productos from './pages/Productos';
import Sucursales from './pages/Sucursales';
import Traslados from './pages/Traslados';
import Inventario from './pages/Inventario';
import InventarioSucursal from './pages/InventarioSucursal';
import CrearTraslado from './pages/CrearTraslado';
import Ajustes from './pages/Ajustes';
import StandMovil from './pages/StandMovil';
import Facturacion from './pages/Facturacion';
import Pantalla from './pages/Pantalla';

//REACT_APP_API_URL=http://origenesvenezuela.com/origin/api

function AppLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  useEffect(() => {
    const handler = () => { if (window.innerWidth > 768) setSidebarOpen(false); };
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);

  return (
    <div style={{ display: 'flex', minHeight: '100vh' }}>
      <Sidebar isOpen={sidebarOpen} onClose={() => setSidebarOpen(false)} />

      <div
        className="main-wrapper"
        style={{
          marginLeft: 'var(--orig-sidebar-w)',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: '100vh',
          background: 'var(--orig-black)',
        }}
      >
        <Topbar onMenuClick={() => setSidebarOpen(true)} />
        <main style={{ flex: 1 }}>
          <Routes>
            <Route path="/" element={<Dashboard />} />
            <Route path="/productos" element={<Productos />} />
            <Route path="/sucursales" element={<Sucursales />} />
            <Route path="/sucursales/:id/inventario" element={<InventarioSucursal />} />
            <Route path="/crear-traslado" element={<CrearTraslado />} />
            <Route path="/stand-movil" element={<StandMovil />} />
            <Route path="/facturacion" element={<Facturacion />} />
            <Route path="/ajustes" element={<Ajustes />} />
            <Route path="/traslados" element={<Traslados />} />
            <Route path="/inventario" element={<Inventario />} />
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
      </div>
    </div>
  );
}

export default function App() {
  const [theme, setTheme] = useState(
    () => localStorage.getItem('origenes_theme') || 'light'
  );

  const toggleTheme = () => setTheme(t => {
    const next = t === 'dark' ? 'light' : 'dark';
    localStorage.setItem('origenes_theme', next);
    return next;
  });

  useEffect(() => {
    document.documentElement.setAttribute('data-theme', theme);
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      <AuthProvider>
        <HashRouter>
          <Routes>
            <Route path="/login" element={<Login />} />
            {/* Pantalla de cocina: pantalla completa, sin sidebar ni topbar */}
            <Route
              path="/pantalla"
              element={
                <PrivateRoute>
                  <Pantalla />
                </PrivateRoute>
              }
            />
            <Route
              path="/*"
              element={
                <PrivateRoute>
                  <AppLayout />
                </PrivateRoute>
              }
            />
          </Routes>
        </HashRouter>
      </AuthProvider>

      <style>{`
        @media (max-width: 768px) {
          .main-wrapper { margin-left: 0 !important; }
          .orig-sidebar { transform: translateX(-100%); }
          .orig-sidebar.open { transform: translateX(0); box-shadow: 4px 0 24px rgba(0,0,0,0.6); }
          #hamburger-btn { display: flex !important; }
          .sidebar-overlay { display: block !important; }
        }
      `}</style>
    </ThemeContext.Provider>
  );
}

function NotFound() {
  return (
    <div style={{ padding: 48, textAlign: 'center', color: 'var(--orig-text-muted)' }}>
      <i className="bi bi-map" style={{ fontSize: 48, display: 'block', marginBottom: 14, color: 'var(--orig-green)' }} />
      <h4 style={{ color: 'var(--orig-text)', fontFamily: 'var(--orig-font-display)', marginBottom: 8 }}>
        Página no encontrada
      </h4>
      <p style={{ fontSize: 13 }}>La ruta solicitada no existe.</p>
    </div>
  );
}
